import Vue from 'vue';
import AccordionTab from 'primevue/accordiontab';

Vue.component('AccordionTab', AccordionTab);
